import { secureGet } from "config/encryption_decryption/get_post_encryptDecrypt";

export const getWalletHistory = async (panelListId, page) => {
  return secureGet("/api/survey/getWalletHistory", { panelListId, page });
};